/**
 * Lat lasting av Lipscore-widgets (Claude 27.09.2026).
 *
 * Elementer med data-mm-lipscore-lazy="<klasse>" (og eventuelt data-mm-lipscore-lazy-id="<id>") rendres
 * uten Lipscore-klassen og -ID-en, så Lipscore ignorerer dem. Når elementet er innenfor ca. 1,5
 * skjermhøyder, settes klasse og ID på, og Lipscore bes om å tegne widgeten.
 * Brukes av snippets/lipscore-review-list.liquid (anmeldelseslisten nederst på produktsiden).
 *
 * Stjernene i Googles søkeresultater (snitt og antall) kommer fra stjernewidgeten øverst på siden og
 * påvirkes ikke (kontrollert 27.09.2026). Er Lipscore ikke lastet ennå når klassen settes på, finner
 * Lipscore widgeten selv når scriptet starter.
 */
(() => {
  if (window.__mmLipscoreLazy) return;
  window.__mmLipscoreLazy = true;

  const SELECTOR = '[data-mm-lipscore-lazy]';
  const PREFETCH_SCREENS = 1.5;
  let observer = null;

  function renderWidgets() {
    try {
      if (window.lipscore && typeof window.lipscore.initWidgets === 'function') {
        window.lipscore.initWidgets();
      }
    } catch (error) {
      console.warn('Lipscore lazy init', error);
    }
  }

  function activate(element) {
    const classes = (element.getAttribute('data-mm-lipscore-lazy') || '').split(/\s+/).filter(Boolean);
    const id = element.getAttribute('data-mm-lipscore-lazy-id');
    element.removeAttribute('data-mm-lipscore-lazy');
    element.removeAttribute('data-mm-lipscore-lazy-id');
    if (id && !document.getElementById(id)) element.id = id;
    if (classes.length > 0) element.classList.add(...classes);
    if (observer) observer.unobserve(element);
    renderWidgets();
  }

  function start() {
    const elements = Array.from(document.querySelectorAll(SELECTOR));
    if (elements.length === 0) return;

    // A link straight to the reviews: render at once.
    if (/review|omtale|recension|anmeld/i.test(window.location.hash)) {
      elements.forEach(activate);
      return;
    }

    if (typeof IntersectionObserver === 'undefined') {
      elements.forEach(activate);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) activate(entry.target);
          });
        },
        { rootMargin: `${PREFETCH_SCREENS * 100}% 0px` }
      );
    }

    elements.forEach((element) => observer.observe(element));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();